/**
* Mobile Menu Script
* ------------------------------------------------------------------------------
* Exposes methods and events for the mobile menu
*
* @namespace - mobileMenu
*/

var $ = require("jquery");
var Drawer = require('../../drawer/js/drawer');

var $window = $(window);
var $body   = $(document.body);

var selectors = {
    drawer: '[data-mobile-menu-drawer]',
    toggle: '[data-mobile-menu-toggle]',
    submenu: '[data-mobile-submenu]',
    submenuTrigger: '[data-mobile-submenu-trigger]'
};

function MobileMenu(container) {
    container = container || "body";

    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.' + this.name;

    this.mobileMenuDrawer = new Drawer($(selectors.drawer));

    $(selectors.toggle).on('click', this.onToggleClick.bind(this));
    $(selectors.submenuTrigger, this.$container).on('click', this.onSubmenuTriggerClick.bind(this));
}

MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {
    onToggleClick: function(e) {
        e.preventDefault();
        this.mobileMenuDrawer.toggleVisibility();
    },

    onSubmenuTriggerClick: function(e) {
        e.preventDefault();
        var $trigger = $(e.currentTarget);
        var $submenu = $trigger.siblings(selectors.submenu); // Trigger has to be sibling to the submenu element!

        $submenu.slideToggle({
            duration: this.transitionDuration
        });
    }
});

module.exports = MobileMenu;



//////////////////
// WEBPACK FOOTER
// ./navigation/js/mobileMenu.js
// module id = 144
// module chunks = 3